import { gql } from "@apollo/client";

export const GET_ALL_SEVA_TYPES = gql`
  query GetAllSevaTypes {
    getAllSevaTypes {
      seva_type_id
      temple_id
      seva_name
      service_type
      sub_seva_type
      default_duration_minutes
      additional_instructions
      price
      is_active
      createdAt
      serviceTime
      timings
      day
    }
  }
`;

export const GET_ALL_SEVA_TYPES_WITH_PAGINATION = gql`
  query GetAllSevaTypesWithPagination($input: PaginationInput) {
    getAllSevaTypesWithPagination(input: $input) {
      data {
        seva_type_id
        temple_id
        seva_name
        service_type
        sub_seva_type
        default_duration_minutes
        additional_instructions
        price
        is_active
        createdAt
        serviceTime
        timings
        day
      }
      pagination {
        total
        page
        limit
        totalPages
      }
    }
  }
`;

export const GET_SEVA_TYPE_BY_ID = gql`
  query GetSevaTypeById($seva_type_id: ID!) {
    getSevaTypeById(seva_type_id: $seva_type_id) {
      seva_type_id
      temple_id
      seva_name
      service_type
      sub_seva_type
      default_duration_minutes
      additional_instructions
      price
      is_active
      createdAt
       serviceTime
      timings
      day
    }
  }
`;

export const GET_SEVA_TYPES_BY_TEMPLE_ID = gql`
  query GetSevaTypesByTempleId($temple_id: ID!) {
    getSevaTypesByTempleId(temple_id: $temple_id) {
      seva_type_id
      temple_id
      seva_name
      service_type
      sub_seva_type
      default_duration_minutes
      additional_instructions
      price
      is_active
      createdAt
       serviceTime
      timings
      day
    }
  }
`;

export const CREATE_SEVA_TYPE = gql`
  mutation CreateSevaType($input: createSevaTypeInput) {
    createSevaType(input: $input) {
      seva_type_id
      temple_id
      seva_name
      service_type
      sub_seva_type
      default_duration_minutes
      additional_instructions
      serviceTime
      timings
      price
      is_active
      createdAt
    }
  }
`;


export const UPDATE_SEVA_TYPE = gql`
  mutation UpdateSevaType($input: updateSevaTypeInput) {
    updateSevaType(input: $input) {
      seva_type_id
      seva_name
      service_type
      sub_seva_type
      default_duration_minutes
      additional_instructions
      price
      is_active
       serviceTime
      timings
    }
  }
`;


export const DELETE_SEVA_TYPE = gql`
  mutation DeleteSevaType($seva_type_id: ID!) {
    deleteSevaType(seva_type_id: $seva_type_id)
  }
`;
